import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Img from "gatsby-image"
import ArrowRight from "../../../images/arrow-right.svg"
import { useTranslateValue } from "../../../data/TranslateContext"

export default function MilkshakeCottonCandyCup(props) {
  const images = useStaticQuery(graphql`
    query cupImageMilkshakeCottonCandyCup {
      cupImageLarge: file(
        relativePath: {
          eq: "front-page-flavors/milkshake-cotton-candy-can.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageMedium: file(
        relativePath: {
          eq: "front-page-flavors/milkshake-cotton-candy-can.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 260) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageSmall: file(
        relativePath: {
          eq: "front-page-flavors/milkshake-cotton-candy-can.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 180) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const cupSources = [
    images.cupImageLarge.childImageSharp.fluid,
    {
      ...images.cupImageMedium.childImageSharp.fluid,
      media: `(max-width: 768px)`,
    },
    {
      ...images.cupImageSmall.childImageSharp.fluid,
      media: `(max-width: 540px)`,
    },
  ]

  const [{ language }] = useTranslateValue()

  return (
    <>
      <Img fluid={cupSources} />
      <div className="flavor-label">
        {language === "en" && <h2>Cotton Candy</h2>}
        {language === "fr" && <h2>Barbe à Papa</h2>}

        <Link to="/flavors" state={{ flavor: "milkshakeCottonCandy" }}>
          {language === "en" && "Check out the details"}
          {language === "fr" && "Consultez les détails"}
          <ArrowRight />
        </Link>
      </div>
    </>
  )
}

const Svg = styled.svg`
  .active-bg-1 {
    transition: all 0.2s ease-in-out;
    opacity: ${props => (props.active ? 1 : 0)};
  }

  .active-bg-2 {
    transition: all 0.2s ease-in-out;
    opacity: ${props => (props.active ? 1 : 0)};
  }

  .border {
    transition: all 0.2s ease-in-out;
    fill: ${props => (props.active ? "#004F7D" : props.theme.color.primary)};
  }
`
export function MilkshakeCottonCandyThumb(props) {
  const { active } = props

  return (
    <>
      {/* Cotton Candy */}
      {/* <Svg
        version="1.1"
        viewBox="0 0 146 146"
        xmlns="http://www.w3.org/2000/svg"
        active={active}
      >
        <path
          className="active-bg-1"
          d="m50.81 82.971c0.27095 11.865 10.489 21.349 23 21.349s22.729-9.4843 23-21.349c0-15.159-18.732-38.26-23.059-42.651-4.5968 4.3705-22.941 27.717-22.941 42.651z"
          fill="#C8E6D7"
        />
        <path
          className="border"
          d="m73.54 37.85 0.17653 0.0037566 0.14722 0.018152c0.58661 0.11198 1.4908 0.79627 4.8362 4.9781l0.35158 0.44796c1.8699 2.4066 4.5679 6.2413 8.0938 11.504 5.0223 7.9994 10.715 19.109 10.715 28.158-0.25786 12.714-10.239 22.987-22.759 23.778l-5.853e-4 9.9821c0.010796 0.40471-0.14246 0.7966-0.42494 1.0866-0.28248 0.29002-0.6702 0.45339-1.0751 0.45339-0.82843 0-1.5-0.67157-1.5-1.5l2.099e-4 -10.015c-12.572-0.7372-22.612-11.033-22.87-23.785 0-9.2782 5.8513-20.629 10.872-28.61l0.92675-1.384c6.7822-10.077 10.953-15.116 12.511-15.116zm-0.1 3.47-0.27065 0.27823-0.29353 0.3146c-5.0156 5.4708-20.696 27.065-20.696 41.077 0.031731 11.282 8.8187 20.5 19.92 21.224l-2.377e-4 -6.6621-10.22-10.872c-0.45911-0.37098-0.65797-0.97672-0.50808-1.5476 0.14989-0.57091 0.62066-1.0008 1.2028-1.0984 0.58213-0.097603 1.1674 0.15527 1.4953 0.64607l8.03 8.481v-17.139l-6.26-6.672c-0.57714-0.59647-0.56147-1.5479 0.035-2.125s1.5479-0.56147 2.125 0.035l4.1 4.37v-20.22c0-0.82843 0.67157-1.5 1.5-1.5s1.5 0.67157 1.5 1.5v20.381l4.18-4.171c0.27993-0.28337 0.66168-0.44286 1.06-0.44286s0.78007 0.15949 1.06 0.44286c0.57946 0.58788 0.57946 1.5321 0 2.12l-6.3 6.374v17.334l8.18-8.188c0.27993-0.28337 0.66168-0.44286 1.06-0.44286s0.78007 0.15949 1.06 0.44286c0.57946 0.58788 0.57946 1.5321 0 2.12l-10.3 10.279 5.808e-4 6.5396c10.884-0.82248 19.491-9.8085 19.705-20.857l0.0039966-0.35184c0-14.81-17.37-37.38-21.37-41.67zm24.12 13.42c1.215 0 2.2 0.98497 2.2 2.2s-0.98497 2.2-2.2 2.2-2.2-0.98497-2.2-2.2 0.98497-2.2 2.2-2.2zm-48.88-1.15c1.4801 0 2.68 1.1999 2.68 2.68s-1.1999 2.68-2.68 2.68-2.68-1.1999-2.68-2.68 1.1999-2.68 2.68-2.68zm7.35-7.27c1.3697 0 2.48 1.1103 2.48 2.48s-1.1103 2.48-2.48 2.48-2.48-1.1103-2.48-2.48 1.1103-2.48 2.48-2.48zm35.43-4.17c1.9717 0 3.57 1.5983 3.57 3.57s-1.5983 3.57-3.57 3.57-3.57-1.5983-3.57-3.57 1.5983-3.57 3.57-3.57zm-42.07-2.07c1.0825 0 1.96 0.87752 1.96 1.96s-0.87752 1.96-1.96 1.96-1.96-0.87752-1.96-1.96 0.87752-1.96 1.96-1.96zm10.85-7.21c2.0048 0 3.63 1.6252 3.63 3.63s-1.6252 3.63-3.63 3.63-3.63-1.6252-3.63-3.63 1.6252-3.63 3.63-3.63zm23.53 3.02c1.0107 0 1.83 0.81932 1.83 1.83s-0.81932 1.83-1.83 1.83-1.83-0.81932-1.83-1.83 0.81932-1.83 1.83-1.83zm12.8-5.03c1.4801 0 2.68 1.1999 2.68 2.68s-1.1999 2.68-2.68 2.68-2.68-1.1999-2.68-2.68 1.1999-2.68 2.68-2.68zm-23.11-3.86c1.4801 0 2.68 1.1999 2.68 2.68s-1.1999 2.68-2.68 2.68-2.68-1.1999-2.68-2.68 1.1999-2.68 2.68-2.68z"
          fill="#228282"
        />
      </Svg> */}
      <Svg
        viewBox="0 0 146 146"
        xmlns="http://www.w3.org/2000/svg"
        active={active}
      >
        <path
          className="active-bg-1"
          d="M87.0977 90.5857C87.2911 90.1961 87.4844 89.7415 87.6134 89.3518C85.8086 89.157 84.0682 88.7674 82.4568 88.053C82.3924 88.053 82.3924 87.9881 82.3279 87.9881C81.49 87.5984 81.1032 86.5594 81.49 85.7152C81.8767 84.806 82.908 84.3514 83.8104 84.7411C85.7441 85.5203 87.8067 85.91 89.9338 85.91C95.9283 85.845 101.343 82.4032 104.05 77.0781C107.144 70.9737 105.79 64.2198 100.505 59.0246C99.3445 57.8557 97.9909 56.8816 96.5728 56.0373C95.7349 55.5178 95.4126 54.4138 95.9283 53.5696C96.4439 52.7254 97.5397 52.4007 98.3776 52.9202C99.3445 53.4397 100.247 54.0891 101.085 54.8035C105.017 45.1923 103.921 36.5552 100.182 33.0484L98.6999 36.0357C96.4439 40.4516 91.094 42.205 86.711 39.997L72.2727 32.4639C66.9872 29.7364 60.5415 31.8795 57.8343 37.2046C57.5121 37.854 57.2542 38.5683 57.0609 39.2177C58.1566 39.4775 59.1879 39.8671 60.2192 40.4516C61.1216 40.9062 61.4439 42.0102 60.9927 42.8544C60.5415 43.6986 59.4458 44.0233 58.6078 43.6337C57.4476 43.0492 56.094 42.5946 54.8049 42.3998C49.455 41.6205 44.2984 44.348 41.8491 49.1536C39.4642 53.8294 40.2377 59.5441 43.7183 63.3756C44.7496 64.4796 45.9099 65.4537 47.2634 66.1031C48.1014 66.6226 48.4881 67.5968 48.1014 68.5059C47.6502 69.4151 46.6189 69.7398 45.7165 69.3501C45.652 69.3501 45.5876 69.2852 45.5876 69.2852C44.5563 68.7657 43.5894 68.1163 42.7515 67.4019C42.687 67.5318 42.6226 67.6617 42.5581 67.7916C40.0443 72.4673 41.5268 78.3769 45.8454 81.4291C46.5544 81.9486 46.8123 82.9227 46.4255 83.702C45.9743 84.6112 46.2966 85.845 47.1345 86.2347L53.7091 89.6116L62.862 94.2874L69.4366 97.6643C70.339 98.1189 71.3703 97.7293 71.8215 96.8851C72.2082 96.1058 73.175 95.7161 74.013 95.9759C79.0406 97.7293 84.6483 95.3914 87.0977 90.5857ZM64.989 46.9457C64.0867 46.4911 63.7644 45.3871 64.2156 44.5429C64.6668 43.6337 65.7625 43.309 66.6005 43.7636L69.7588 45.3871C70.6612 45.8417 70.9835 46.9457 70.5323 47.7899C70.0811 48.6341 68.9854 49.0238 68.1474 48.5692L64.989 46.9457ZM75.9467 84.8709L69.5655 81.6239C68.6631 81.1693 68.3408 80.0653 68.792 79.2211C69.2432 78.3119 70.339 77.9872 71.1769 78.4418L77.5581 81.6888C78.4605 82.1434 78.7828 83.2474 78.3316 84.0916C77.8804 84.9359 76.7846 85.3255 75.9467 84.8709Z"
          fill="#F1CCE1"
        />
        <path
          className="active-bg-2"
          d="M49.5193 103.639L54.0957 105.976L55.9005 102.859L50.9374 100.327L49.5193 103.639Z"
          fill="#B9E5FA"
        />
        <path
          className="active-bg-2"
          d="M46.0385 111.821C45.8451 112.341 45.8451 112.86 45.974 113.315C46.1674 113.834 46.4897 114.224 46.9409 114.419C47.9077 114.873 49.0679 114.549 49.5836 113.639L52.2263 109.094L48.0366 106.951L46.0385 111.821Z"
          fill="#B9E5FA"
        />
        <path
          className="active-bg-2"
          d="M52.3553 97.0146L57.7697 99.807L59.5745 96.6899L53.8378 93.7026L52.3553 97.0146Z"
          fill="#B9E5FA"
        />
        <path
          className="border"
          d="M103.792 57.2712C109.142 45.1273 107.659 32.4639 100.247 28.6324C99.3444 28.1778 98.313 28.5675 97.8619 29.4117L95.4125 34.2173C94.0589 36.8798 90.8361 37.9189 88.1933 36.5551L73.884 29.2818C66.8582 25.7101 58.221 28.5025 54.6759 35.581C54.1602 36.6201 53.7735 37.6591 53.5156 38.6982C47.3278 38.5034 41.4622 41.8803 38.5616 47.5301C35.79 53.115 36.499 59.7389 40.1086 64.6094C39.7863 65.064 39.5285 65.5836 39.2707 66.0381C36.3057 72.0776 37.7882 79.286 42.7513 83.5721C42.4291 85.3255 42.9447 87.0789 44.105 88.3777C44.4917 88.8323 45.0073 89.2219 45.5875 89.4817L50.5506 92.0144L50.6795 92.0793L47.0055 100.716L42.8158 110.393C42.2357 111.756 42.2357 113.185 42.6869 114.549C43.1381 115.913 44.105 117.017 45.3941 117.666C47.6501 118.835 50.3573 118.25 52.0331 116.432C52.291 116.172 52.5488 115.848 52.7422 115.458L62.7974 98.2487L62.9908 98.3786L67.825 100.846C69.7587 101.82 71.9503 101.561 73.5617 100.262C73.755 100.067 73.9484 99.9372 74.1418 99.7423C80.4585 101.236 87.2265 98.1188 90.256 92.1442C90.7072 91.2351 91.0294 90.261 91.2873 89.2869C98.0552 88.7024 103.985 84.741 107.079 78.5717C110.753 71.4931 109.4 63.4405 103.792 57.2712ZM49.6482 113.64C49.1326 114.549 47.9724 114.938 47.0055 114.419C46.5543 114.159 46.232 113.77 46.0387 113.315C45.8453 112.86 45.9097 112.341 46.1031 111.821L48.1657 106.951L52.3554 109.094L49.6482 113.64ZM54.0957 105.977L49.5193 103.639L50.9374 100.327L55.9005 102.859L54.0957 105.977ZM57.7698 99.8073L52.4199 97.0798L53.8379 93.7678L59.5746 96.6901L57.7698 99.8073ZM103.921 76.9482C101.214 82.3382 95.7992 85.7151 89.8048 85.7801C87.6777 85.7801 85.6151 85.4554 83.6814 84.6111C82.779 84.2215 81.7477 84.6761 81.3609 85.5852C81.0386 86.4295 81.3609 87.4685 82.1989 87.8582C82.2633 87.8582 82.2633 87.9231 82.3278 87.9231C84.0037 88.5725 85.744 89.0271 87.4843 89.2219C87.3554 89.6116 87.162 90.0661 86.9687 90.4558C84.5193 95.2614 78.9116 97.6642 73.884 95.9109C73.046 95.6511 72.1436 95.9758 71.6924 96.82C71.2412 97.7292 70.1455 98.0539 69.3075 97.5993L62.7329 94.2224L53.5801 89.5466L47.0055 86.1697C46.1676 85.7151 45.8453 84.5462 46.2965 83.637C46.6832 82.8577 46.4254 81.8836 45.7164 81.3641C41.3977 78.3119 39.9152 72.4023 42.3001 67.6617C42.558 67.5967 42.6224 67.4668 42.6869 67.337C43.5893 68.0513 44.4917 68.7007 45.523 69.2202C45.5875 69.2202 45.6519 69.2852 45.6519 69.2852C46.5543 69.7398 47.5856 69.3501 48.0368 68.4409C48.488 67.5318 48.1013 66.5577 47.1989 66.0381C45.8453 65.3887 44.6206 64.4796 43.6538 63.3106C40.2375 59.5441 39.464 53.8293 41.7845 49.2185C44.2339 44.4129 49.3904 41.6854 54.7403 42.4647C56.0939 42.6596 57.383 43.1141 58.5433 43.6986C59.4457 44.0882 60.477 43.8285 60.9282 42.9193C61.3794 42.0101 61.0571 40.9711 60.1547 40.5165C59.1234 39.997 58.0921 39.6073 56.9963 39.2826C57.1897 38.5683 57.4475 37.9189 57.7698 37.2695C60.477 31.9444 66.9226 29.8013 72.2081 32.5288L86.5175 39.8671C90.9005 42.14 96.3149 40.3217 98.5064 35.9057L100.118 32.9185C103.856 36.4253 104.888 45.0624 101.02 54.6735C100.182 54.0241 99.2799 53.3747 98.3131 52.7903C97.4751 52.3357 96.3793 52.5955 95.8637 53.4397C95.348 54.2839 95.6703 55.3879 96.5083 55.9074C97.9263 56.7516 99.2154 57.7258 100.44 58.8947C105.726 64.1549 107.015 70.8437 103.921 76.9482Z"
          fill="#004F7D"
        />
        <path
          className="border"
          d="M70.5967 47.7899C71.0479 46.8807 70.6612 45.8416 69.8232 45.3871L66.6649 43.7635C65.7625 43.309 64.7312 43.6986 64.28 44.5428C63.8288 45.452 64.2155 46.491 65.0534 46.9456L68.2118 48.5691C69.0498 49.0237 70.1455 48.699 70.5967 47.7899Z"
          fill="#004F7D"
        />
        <path
          className="border"
          d="M78.3315 84.0916C78.7827 83.1824 78.396 82.1434 77.5581 81.6888L71.1768 78.4418C70.2744 77.9872 69.2431 78.3768 68.7919 79.2211C68.3407 80.1302 68.7275 81.1693 69.5654 81.6239L75.9466 84.8709C76.7846 85.3255 77.8803 84.9358 78.3315 84.0916Z"
          fill="#004F7D"
        />
      </Svg>
    </>
  )
}
